import React, { useContext, useEffect } from "react";
import { PayLoadCtx, LangCtx, RoleCtx } from "../../lib/context";
import { useHistory, useParams, useLocation } from 'react-router-dom';
import Loader from "../../lib/ui/loader/Loader";
import { currentuserinfo } from "../../actions/users";
import { langObj } from "../../locale/index";

const ConferenceAccess = (props) => {
    const { setRole } = useContext(RoleCtx);
    const { setPayload } = useContext(PayLoadCtx);
    const { token, sub } = useParams();
    const history = useHistory();
    const { setLang } = useContext(LangCtx);
    const langurl = new URLSearchParams(useLocation().search).get("lang");
    
    useEffect(() => {
        if (token != null && sub != null) {
            const id = new URLSearchParams(props.location.search).get("id");
            const pid = new URLSearchParams(props.location.search).get("pid");
            localStorage.setItem("token", token);
            localStorage.setItem("sub", sub);
            //setLoading(true)
            if (langurl && langurl !== "") {
                setLang(langObj[langurl]);
                localStorage.setItem('lang', langurl);
            }
            currentuserinfo().then(res => {
                //setLoading(false)
                if (res && res.attributes && res.attributes.userId) {
                    setPayload(res && res.attributes ? res.attributes : null);

                    let _role = null;
                    if (res && res.attributes && res.attributes.consultRole === 'patient') {
                        _role = 'P'
                    } else if (res && res.attributes && res.attributes.consultRole === 'doctor') {
                        _role = 'D'
                    } else if (res && res.attributes && res.attributes.consultRole === 'clinic') {
                        _role = 'C'
                    }
                    setRole(_role);
                    _role === 'D' ? history.push(`/doc-conf-settings/${id}/${pid}`) : history.push(`/conference-settings/${id}`)
                }
            }).catch(err => {
                //setLoading(false)
                console.log("err in current userinfo======", err);
            })

        }
    }, [token, sub])


return(
    <div><Loader /></div>
)
}



export default ConferenceAccess;